import { tokenizeSearch, makeVariants, matchesTokens } from '@/components/common/basic/search-highlight/searchHighlight';

/**
 * Проверяет, что текст содержит ВСЕ слова из строки фильтра (AND-логика).
 * Поддерживает RU/EN раскладку. Например, "нов ка" найдёт "Новая папка".
 *
 * @param text — текст для проверки (имя элемента).
 * @param filter — строка поиска (может содержать несколько слов через пробел).
 */
export function matchesText(text: string, filter: string): boolean {
  if (!filter) return true;
  const tokens = tokenizeSearch(filter);
  if (!tokens.length) return true;
  const candidates = makeVariants(text);
  const tokenVariantsCache = tokens.map((t) => makeVariants(t));
  return matchesTokens(candidates, tokenVariantsCache);
}
